import moment from 'moment'
import { twMerge } from 'tailwind-merge'
import React, { useEffect, useState } from 'react'

import { api } from '../services/api.service'

const S3FileViewer = ({ fileKey, ...rest }) => {
    const [fileUrl, setFileUrl] = useState(null)
    const [error, setError] = useState(null)
    const fetchFileUrl = async (key) => {
        try {
            const cachedData = localStorage.getItem(fileKey)
            if (cachedData) {
                const { signedUrl, timestamp } = JSON.parse(cachedData)
                if (moment().diff(moment(timestamp), 'hours') < 12) {
                    setFileUrl(signedUrl)
                    return
                } else {
                    api(`${process.env.REACT_APP_API_URL}/s3/get-signed-url/${encodeURIComponent(key)}`)
                        .then((res) => {
                            setFileUrl(res?.signedUrl ?? null)
                        })
                        .catch((err) => {
                            throw err
                        })
                }
            } else {
                api(`${process.env.REACT_APP_API_URL}/s3/get-signed-url/${encodeURIComponent(key)}`)
                    .then((res) => {
                        setFileUrl(res?.signedUrl ?? null)
                    })
                    .catch((err) => {
                        throw err
                    })
            }
        } catch (err) {
            console.log(err)
            setError(err.message)
        }
    }

    useEffect(() => {
        if (fileKey) {
            fetchFileUrl(fileKey)
        }
    }, [fileKey])

    if (!fileUrl) return <></>

    if (error) {
        return <div>Error: {error}</div>
    }

    return <img src={fileUrl ?? ''} {...rest} className={twMerge('object-cover mx-auto max-h-64', rest?.className)} />
}

export default S3FileViewer
